import { useFetchMixAPi1, useMixApi1Toast } from "hooks";
import { useMxfNestToast } from "hooks/useMxfApiNest";
import { getURLWithParams } from "utils/context";

export const useProductsDirectClassList = (params = {}) => {
  const hasParams = params?.cli_uf && params?.pcli_id_cliente;
  const url = hasParams
    ? getURLWithParams("/legislacao/produtos/class-direta", params)
    : null;

  const result = useFetchMixAPi1(url);

  if (!hasParams) {
    return {
      data: [],
      isLoading: false,
    };
  }

  return result;
};

export const useInsertProductsDirectClass = () => {
  const { onSend } = useMixApi1Toast();

  const onInsert = data =>
    onSend({
      endpoint: "/legislacao/tributacao-direta-produto/bulk-create",
      data,
      messageSuccess: "Produtos classificados com sucesso!",
      messageFail: "Erro ao classificar produtos!",
      type: "POST",
    });

  const onDestroy = data =>
    onSend({
      endpoint: "/legislacao/tributacao-direta-produto/destroy",
      data,
      messageSuccess: "Produtos desclassificados com sucesso!",
      messageFail: "Erro ao desclassificar produtos!",
      type: "DELETE",
    });

  return {
    onInsert,
    onDestroy,
  };
};

export const useNewProductsDirectClass = () => {
  const { onSend } = useMxfNestToast();

  const onInsert = data =>
    onSend({
      endpoint: "/tributacao-direta",
      data,
      messageSuccess: "Produtos classificados com sucesso!",
      messageFail: "Erro ao classificar produtos!",
      type: "POST",
    });

  const onDestroy = data =>
    onSend({
      endpoint: "/tributacao-direta/bulk",
      data,
      messageSuccess: "Produtos desclassificados com sucesso!",
      messageFail: "Erro ao desclassificar produtos!",
      type: "DELETE",
    });

  const onDestroyEstado = data =>
    onSend({
      endpoint: "/tributacao-direta/estado/bulk",
      data,
      messageSuccess: "Tributações por estado removidas com sucesso!",
      messageFail: "Erro ao remover tributações por estado!",
      type: "DELETE",
    });

  return {
    onInsert,
    onDestroy,
    onDestroyEstado,
  };
};
